const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
/* 
Ciao Solea, spero vada tutto bene. Scusa se ti sto rispondendo solo ora ma ho dovuto analizzare molti freelancer. 
Ho visto i tuoi progetti, ti faccio i i miei più sinceri complimenti! Il design è ben curato ed è ciò che stiamo proprio cercando noi di MadNight.
Vedo che per maggiori dettagli preferisci parlare via chiamata, nessun problema. 

*/

